import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWoningKlaar1 = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="m8 14 12-8 12 8v20H8z"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M20.085 27.85 29.73 6.953l4.54 2.096-12 26-4.568-.063-6-14 4.596-1.97z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M30.45 22.217 25.424 32.64H20.06v-1h4.736l4.754-9.857zM14.875 12.4l-8.6 5.97-.57-.82 8.6-5.97z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWoningKlaar1);

export default ForwardRef;
